import { render, staticRenderFns } from "./LandingTemplate.vue?vue&type=template&id=73b8e9a5&"
import script from "./LandingTemplate.vue?vue&type=script&lang=js&"
export * from "./LandingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LandingTemplate.vue?vue&type=style&index=0&id=73b8e9a5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports